import { connect } from "react-redux";
import * as Redux from "redux";
import { withRouter } from "react-router-dom";
import { getAggregatedMetrics } from "../../actions";
import { MetricsContainer } from "./component";
export interface MetricsContainerProps {
  metrics_container_tab: string;
}
const mapStateToProps = (state: any, props: any): MetricsContainerProps => {
  return {
    metrics_container_tab: state.analytics.metrics_container_tab
  };
};

export default withRouter(connect(mapStateToProps)(MetricsContainer));



// WEBPACK FOOTER //
// ./client/modules/Analytics/components/MetricsContainer/container.ts